@if(isDisabled){
<app-loader></app-loader>
}
<form name="RouteForm" (ngSubmit)="RouteForm.form.valid && Save()" #RouteForm="ngForm">
    <div class="card">
        <div class="card-header">
            Route Master
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-12 px-1">
                    <label>Code<span class="text-danger">*</span></label>
                    <input name="Code" maxlength="100" class="form-control" placeholder="Ex." [(ngModel)]="Detail.Code"
                        #Code="ngModel" required disabled>
                    <div class="invalid-feedback">
                        Please enter Code.
                    </div>
                </div>
                <div class="col-md-12 px-1">
                    <label>Name<span class="text-danger">*</span></label>
                    <input name="routename" maxlength="200" class="form-control" placeholder="Ex."
                        [(ngModel)]="Detail.RouteName" #routename="ngModel" required>
                    <div class="invalid-feedback">
                        Please enter Name.
                    </div>
                </div>
                <div class="col-md-12 px-1">
                    <label class="Label">Cluster<span class="text-danger">*</span></label>
                    <ng-select name="cluster" [items]="ClusterLoad" bindLabel="ClusterName" bindValue="ESS_ClusterMasterID"
                        [(ngModel)]="Detail.ESS_ClusterID" placeholder="Select Cluster" required [disabled]="id>0">
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select Cluster.
                    </div>
                </div>
                <div class="col-md-12 px-1">
                    <label class="Label">SiteOwner<span class="text-danger">*</span></label>
                    <ng-select name="siteowner" [items]="SiteOwnerLoad" bindLabel="SiteOwnerName"
                        bindValue="SiteOwnerID" [(ngModel)]="Detail.ESS_SiteOwnerID" placeholder="Select Siteowner"
                        required>
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select SiteOwner.
                    </div>
                </div>

            </div>
        </div>
        <div class="card-footer">
            <div class="row">
                <div class="col">
                </div>
                <div class="col-auto">
                    <div class="col-auto">
                        <button type="button" class="btn btn-outline-primary me-1" (click)="close()"
                            [disabled]="isDisabled" ngbTooltip="Cancel" container="body" placement="top">
                            Cancel
                            <span *ngIf="isDisabled" class="spinner-border spinner-border-sm" role="status"
                                aria-hidden="true"></span>
                        </button>

                        <button
                            *ngIf="(this.id == 0 && this.common.PageRight.IsAdd) || (this.id > 0 && this.common.PageRight.IsEdit)"
                            type="submit" class="btn btn-primary" [disabled]="isDisabled"><i class="bi bi-save2"
                                *ngIf="!isDisabled"></i>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                *ngIf="isDisabled"></span>
                            {{!isDisabled?'Save':'Loading...'}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>